import React from "react";
import { Dialog as MUIDialog } from "@mui/material";
import styled from "styled-components";

const StyledMUIDialog = styled(MUIDialog)`
  .MuiDialog-paper {
    border-radius: 16px;
  }
`;

export const Dialog = (props) => {
  return <StyledMUIDialog {...props} />;
};
